export const AsistenteBicentenarioEntity = {
    id: null,
    docIdentidad: '',
    nombre: '',
    apellido: '',
    nroTelefono: '',
    email: ''
};
